import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.regexp.split";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { getAction } from '@/api/manage';
import { GetSiteIdMixin } from '@/mixins/GetSiteIdMixin';
import moment, { months } from 'moment';
import waterKLineChart from '@/components/biChart/waterKLineChart';
import colControl from '@/components/colControl/colControl';
export default {
  name: 'kLineAnalysis',
  mixins: [GetSiteIdMixin],
  components: {
    waterKLineChart: waterKLineChart,
    colControl: colControl
  },
  data: function data() {
    return {
      colOptions: [],
      initNum: 0,
      limitSelectDate: {},
      stime: '',
      etime: '',
      quantum: '',
      dateFormat: 'YYYY-MM-DD',
      chartBoxHeight: '604px',
      tableData: [],
      labelCol: {
        xs: {
          span: 24
        },
        sm: {
          span: 8
        }
      },
      wrapperCol: {
        xs: {
          span: 24
        },
        sm: {
          span: 16
        }
      }
    };
  },
  created: function created() {
    this.limitSelectDate = {
      min: moment().startOf('day').subtract(1, 'months'),
      max: moment().endOf('day')
    };
    this.stime = this.limitSelectDate.min.format('YYYY-MM-DD');
    this.etime = this.limitSelectDate.max.format('YYYY-MM-DD');
  },
  watch: {
    currentSiteId: function currentSiteId(value) {}
  },
  filters: {
    weekFormat: function weekFormat(val) {
      var week = '';

      switch (val) {
        case 1:
          week = '周一';
          break;

        case 2:
          week = '周二';
          break;

        case 3:
          week = '周三';
          break;

        case 4:
          week = '周四';
          break;

        case 5:
          week = '周五';
          break;

        case 6:
          week = '周六';
          break;

        case 7:
          week = '周日';
          break;
      }

      return week;
    },
    monthFormat: function monthFormat(date) {
      var time = new Date(date);
      var month = time.getMonth() + 1;
      month = month > 9 ? month : '0' + month;
      return time.getFullYear() + '-' + month;
    },
    dayFormat: function dayFormat(time) {
      var date = time.split(' ');
      var dateTime = date[1].split(':');
      return date[0] + ' ' + dateTime[0];
    }
  },
  methods: {
    onChange: function onChange() {
      var selectedtargetList = JSON.parse(JSON.stringify(this.$refs.charts.targetListSource));
      var arr = [];
      this.$refs.colControl.selectCol.forEach(function (item) {
        selectedtargetList.forEach(function (item1, index1) {
          if (item == item1.code) {
            arr.push(item1);
          }
        });
      });
      this.$refs.charts.targetList = arr;
      this.$refs.charts.targetType = this.$refs.charts.targetList[0].code;
      this.$refs.charts.changeChartInit();
    },
    openCol: function openCol(index) {
      if (typeof index == 'number') {
        this.$refs.colControl[0].visible = true;
      } else {
        this.$refs.colControl.visible = true;
      }
    },
    moment: moment,
    searchChart: function searchChart() {
      this.initNum++;
    },
    getWeek: function getWeek(dt) {
      var d1 = new Date(dt);
      var d2 = new Date(dt);
      d2.setMonth(0);
      d2.setDate(1);
      var rq = d1 - d2;
      var days = Math.ceil(rq / (24 * 60 * 60 * 1000));
      var num = Math.ceil(days / 7);
      return num + 1;
    },
    onallChange: function onallChange(date, dateString) {
      this.stime = dateString[0];
      this.etime = dateString[1];
      console.log('实时数据/日数据', dateString);
    }
  }
};